import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import PayPalCheckout from "../auth/PayPalCheckout";
import AdBlockIcon from "../../assets/img/adblock-icon.svg";
import AboIcon from "../../assets/img/abo-icon.svg";
import { MdOutlineCookie } from "react-icons/md";

import "../../assets/css/adblockwarning.css";

const AdBlockWarning = ({ previousPath }) => {
  const { user } = useAuth();
  const [showPayPal, setShowPayPal] = useState(false);

  return (
    <>
      <main>
        <div className="adblock">
          <div className="wrapper">
            <div className="adblock-warning">
              <div className="adblock-headline">
                <h1>Aufgrund Deines Blockers zeigen<br />wir ngctv.de nicht an.</h1>
                <img className="adblock-icon" src={AdBlockIcon} alt="NGCTV Logo" />
              </div>
              <p>Du hast folgende zwei Optionen:</p>
              <div className="cards">
                <div className="card">
                  <h2>Deaktiviere deinen AdBlocker</h2>
                  <ol>
                    <li>Klicke auf das Symbol deines Werbe- oder Cookiebanner-Blockers.</li>
                    <li>Schalte Werbung für ngctv.de frei.</li>
                    <li>Aktualisiere die Seite.</li>
                  </ol>
                </div>
                <div className="card">
                  <h2>Abonniere ngctv.de</h2>
                  <ul>
                    <li>Alle Artikel und Tests ohne Werbung</li>
                    <li>Exklusiver Abonnentenbereich</li>
                    <li>Spezielle Abonnentenrolle</li>
                  </ul>

                  {user ? (
                    showPayPal ? (
                      <PayPalCheckout userId={user.id} />
                    ) : (
                      <button onClick={() => setShowPayPal(true)} className="btn-login">
                        ngctv.de Abo kaufen
                      </button>
                    )
                  ) : (
                    <>
                      <Link to="/register" className="btn-login" viewTransition>Jetzt registrieren und Abo kaufen</Link>
                      <Link to="/login" className="btn-none" viewTransition>Ich habe bereits ein Konto</Link>
                    </>
                  )}
                </div>
              </div>

              <div className="wrapper">
                <h2>Warum ist die Nutzung von ngctv.de nur ohne Adblocker möglich?</h2>
                <p>Der Besuch unserer Website ist kostenlos, da wir uns über Werbung finanzieren.</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AdBlockWarning;
